import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingComponent } from './components/loading/loading.component';
import { BannerComponent } from './components/banner/banner.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CommonModule, DatePipe } from '@angular/common';
import { AutorizationComponent } from './components/autorization/autorization.component';
import { SelectsComponent } from './components/selects/selects.component';
import { LoadExcelComponent } from './components/LoadExcel/loadexcel.component';
import { TableComponent } from './components/table/table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { StatusComponent } from './components/status/status.component';
import { DialogRegisterComponent } from './components/dialog-register/dialog-register.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBadgeModule } from '@angular/material/badge';
import { NgChartsModule } from 'ng2-charts';
import { ChartComponent } from './components/chart/chart.component';
import { ProductsComponent } from './components/products/products.component';
import { AuthorizationManagementComponent } from './components/authorizationmanagement/authorizationmanagement.component';
import { ChangePasswordDialogComponent } from './components/changePasswordDialog/changePasswordDialog.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { PersonalInformationUrlComponent } from './components/personal-information-url/personal-information-url.componente';
import { DialogPatientDataComponent } from './components/dialog-patient-data/dialog-patient-data.component';
import { ButtonsComponent } from './components/buttons/buttons.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterCodPipe } from './components/filters/filterCod.pipe';
import { FilterEpsPipe } from './components/filters/filterEps.pipe';
import { FilterMedicamentoByNamePipe } from './components/filters/filterMedicamentoByName.pipe';
import { DialogMessageInfoComponent } from './components/dialog-message-info/dialog-message-info.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { HistoryProductsComponent } from './components/history-products.component.ts/history-products.component';
import { DialogUpdatePatient } from './components/dialog-update-patient/dialog-update-patient.component';
import { DialogMessageFailComponent } from './components/dialog-message-fail/dialog-message-fail.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MY_DATE_FORMATS } from './custom-date-formats';
import { AuthorizationQueryComponent } from '../patients/components/authorization-query/authorization-query.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DialogUltimaEntregaComponent } from './components/dialog-ultima-entrega/dialog-ultima-entrega.component';
import { BottomNavComponent } from './components/nav/nav.component';
import { DialogMedicamentosComponent } from './components/dialog-medicamentos/dialog-medicamentos.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DialogTratamientoMedicoComponent } from './components/dialogTratamientoMedico/dialog-tratamiento-medico.component';
import { MatRadioModule } from '@angular/material/radio';
import { DialogDocumentsComponent } from './components/dialog-documents/dialog-documents.component';
import { DialogVitalesEstadosComponent } from './components/dialog-vitales-estados/dialog-vitales-estados.component';
import { DialogDossierComponent } from './components/dialog-dossier/dialog-dossier.component';
import { DialogNewAnexosComponent } from './components/dialog-new-anexos/dialog-new-anexos.component';
import { DialogNewRepoComponent } from './components/dialog-new-repo/dialog-new-repo.component';
import { DialogAddDocumentsComponent } from './components/dialog-add-documents/dialog-add-documents.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { DialogAutorizacionesEstadosComponent } from './components/dialog-autorizaciones-estados/dialog-autorizaciones-estados.component';
import { DialogInfoPatientComponent } from './components/dialog-info-patient/info-patient-dialog.component';
import { DialogPqrComponent } from './components/dialog-pqr/dialog-pqr.component';
import { DialogAnexosParaSubsanarComponent } from './components/dialog-anexos-subsanar/dialog-anexos-subsanar.component';
import { DialogAnexosAutoComponent } from './components/dialog-anexos-auto/dialog-anexos-auto.component';
import { DialogAnexosRepoComponent } from './components/dialog-anexos-repo/dialog-anexos-repo.component';
import { DialogIPSComponent } from './components/dialog-ips/dialog-ips.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogAutorizacionesIntegracionComponent } from './components/dialog-autorizaciones-integracion/dialog-autorizaciones-integracion.component';
import { HeaderMovileComponent } from './components/header-movile/header-movile.component';
import { TrimInputDirective } from '../directives/trim-input.directive';
import { DialogFieldsComponent } from './components/dialog-fields/dialog-fields.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DialogRejectComponent } from './components/dialog-reject/dialog-reject.component';
import { TableIntegrationsComponent } from '../distributor/components/integrations/components/table-integrations/table-integrations.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import { MessageDialogComponent } from './components/dialog-message-notification/dialog-message-notification.component';
import { HistoryLabsComponent } from './components/history-labs.component/history-labs.component';
import { DialogModulsComponent } from './components/dialog-moduls/dialog-moduls.component';
import { CreateUserComponent } from '../onboarding/components/create-user-admin/create-user-admin.component';
import { DialogSeleccionMatTableComponent } from './components/dialog-medicamento/dialog-medicamento.component';
import { ModalOpcionesComponent } from './components/modal-opciones/modal-opciones.component';
import { DialogConfirmacionComponent } from './components/dialog-confirmacion/dialog-confirmacion.component';
import { MatMenuModule } from '@angular/material/menu';
import { DialogAuditComponent } from './components/dialog-audit/dialog-audit.component';
import { ConfirmLoadMedicamentoDialogComponent } from './components/confirm-load-medicamento-dialog/confirm-load-medicamento-dialog';
import { ConfirmUnsavedDialogComponent } from './components/confirm-unsaved-dialog/confirm-unsaved-dialog.component';
import { PatientUpdateReviewComponent } from './components/patient-update-review/patient-update-review.component';
import { DialogImportVitalesComponent } from './components/dialog-import-vitales/dialog-import-vitales.component';
import { EditOCDialogComponent } from './components/edit-oc-dialog/edit-oc-dialog.component';
import { ConfirmDeleteOCDialogComponent } from './components/confirm-delete-oc-dialog/confirm-delete-oc-dialog.component';
import { DialogConfirmacionImportacionComponent } from './components/dialog-confirmacion-importacion/dialog-confirmacion-importacion.component';
import { DialogAutorizacionesMutiplesComponent } from './components/dialog-autorizaciones-mutiples/dialog-autorizaciones-mutiples.component';
import { DialogOdooIntegracionComponent } from './components/dialog-odoo-integracion/dialog-odoo-integracion.component';
import { DialogLotesBiibComponent } from './components/dialog-lotes-biib/dialog-lotes-biib.component';
import { DialogInfoFacturaComponent } from './components/dialog-info-factura/dialog-info-factura.component';
import { DialogNotaCreditoComponent } from './components/dialog-nota-credito/dialog-nota-credito.component';
import { DialogStatusRadComponent } from './components/dialog-status-rad/dialog-status-rad.component';
@NgModule({
  declarations: [
    LoadingComponent,
    BannerComponent,
    SidebarComponent,
    AutorizationComponent,
    SelectsComponent,
    LoadExcelComponent,
    TableComponent,
    StatusComponent,
    DialogRegisterComponent,
    ChartComponent,
    ProductsComponent,
    AuthorizationManagementComponent,
    ChangePasswordDialogComponent,
    PersonalInformationUrlComponent,
    DialogPatientDataComponent,
    ButtonsComponent,
    FiltersComponent,
    FilterCodPipe,
    FilterEpsPipe,
    FilterMedicamentoByNamePipe,
    DialogMessageInfoComponent,
    HistoryProductsComponent,
    DialogUpdatePatient,
    DialogMessageFailComponent,
    AuthorizationQueryComponent,
    DialogUltimaEntregaComponent,
    BottomNavComponent,
    DialogMedicamentosComponent,
    DialogTratamientoMedicoComponent,
    DialogDocumentsComponent,
    DialogVitalesEstadosComponent,
    DialogDossierComponent,
    DialogNewAnexosComponent,
    DialogNewRepoComponent,
    DialogAddDocumentsComponent,
    DialogAutorizacionesEstadosComponent,
    DialogInfoPatientComponent,
    DialogPqrComponent,
    DialogAnexosParaSubsanarComponent,
    DialogAnexosAutoComponent,
    DialogAnexosRepoComponent,
    DialogIPSComponent,
    DialogAutorizacionesIntegracionComponent,
    HeaderMovileComponent,
    TrimInputDirective,
    DialogFieldsComponent,
    DialogRejectComponent,
    TableIntegrationsComponent,
    BreadcrumbComponent,
    MessageDialogComponent,
    HistoryLabsComponent,
    DialogModulsComponent,
    CreateUserComponent,
    DialogSeleccionMatTableComponent,
    ModalOpcionesComponent,
    DialogConfirmacionComponent,
    DialogAuditComponent,
    ConfirmLoadMedicamentoDialogComponent,
    ConfirmUnsavedDialogComponent,
    PatientUpdateReviewComponent,
    DialogImportVitalesComponent,
    EditOCDialogComponent,
    ConfirmDeleteOCDialogComponent,
    DialogConfirmacionImportacionComponent,
    DialogAutorizacionesMutiplesComponent,
    DialogOdooIntegracionComponent,
    DialogLotesBiibComponent,
    DialogInfoFacturaComponent,
    DialogNotaCreditoComponent,
    DialogStatusRadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    HttpClientModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatBadgeModule,
    NgChartsModule,
    MatNativeDateModule,
    MatTabsModule,
    MatSortModule,
    MatStepperModule,
    MatExpansionModule,
    MatCardModule,
    MatAutocompleteModule,
    MatRadioModule,
    OverlayModule,
    PortalModule,
    MatTooltipModule,
    MatSlideToggleModule,
    RouterModule
  ],

  exports: [
    TrimInputDirective,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    HttpClientModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatIconModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatBadgeModule,
    NgChartsModule,
    MatNativeDateModule,
    MatTabsModule,
    MatSortModule,
    MatStepperModule,
    MatExpansionModule,
    MatCardModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatSlideToggleModule,
    RouterModule,
    LoadingComponent,
    BannerComponent,
    SidebarComponent,
    AutorizationComponent,
    SelectsComponent,
    LoadExcelComponent,
    TableComponent,
    StatusComponent,
    DialogRegisterComponent,
    ChartComponent,
    ProductsComponent,
    AuthorizationManagementComponent,
    ChangePasswordDialogComponent,
    PersonalInformationUrlComponent,
    DialogPatientDataComponent,
    ButtonsComponent,
    FiltersComponent,
    DialogMessageInfoComponent,
    HistoryProductsComponent,
    DialogUpdatePatient,
    DialogMessageFailComponent,
    AuthorizationQueryComponent,
    DialogUltimaEntregaComponent,
    BottomNavComponent,
    DialogMedicamentosComponent,
    DialogTratamientoMedicoComponent,
    DialogDocumentsComponent,
    DialogVitalesEstadosComponent,
    DialogDossierComponent,
    DialogNewAnexosComponent,
    DialogNewRepoComponent,
    DialogAddDocumentsComponent,
    DialogAutorizacionesEstadosComponent,
    DialogInfoPatientComponent,
    DialogAnexosParaSubsanarComponent,
    DialogAnexosAutoComponent,
    DialogAnexosRepoComponent,
    MatTooltipModule,
    DialogAutorizacionesIntegracionComponent,
    HeaderMovileComponent,
    DialogFieldsComponent,
    DialogRejectComponent,
    TableIntegrationsComponent,
    BreadcrumbComponent,
    MessageDialogComponent,
    HistoryLabsComponent,
    DialogModulsComponent,
    CreateUserComponent,
    DialogSeleccionMatTableComponent,
    ModalOpcionesComponent,
    DialogConfirmacionComponent,
    MatMenuModule,
    DialogAuditComponent,
    ConfirmLoadMedicamentoDialogComponent,
    PatientUpdateReviewComponent,
    DialogImportVitalesComponent,
    EditOCDialogComponent,
    ConfirmDeleteOCDialogComponent,
    DialogConfirmacionImportacionComponent
  ],
  providers: [
    DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' }, // Configura el locale en español
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  bootstrap: []
})
export class SharedModule {
  constructor(private dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('es-ES'); // Establece el locale
  }
}

